import { Card, Col, Flex, Row, Typography } from '@jcm/design-system';
import React from 'react';
import estilos from './index.module.scss';
import { iconeNotificacao } from '../../../../components/NotificacoesUsuario/RecuperarIconeNotificacao/recuperarIconeNotificacao';
import { formatarDataPtBr } from '../../../../utils/datas/formatarDataPtBr';

interface CartaoNovidadeProps {
	descricao: string;
	tipoNovidade: number;
	onDelete: (index: number) => JSX.Element;
	indice: number;
	dataInserida: string;
}

const CartaoNovidades: React.FC<CartaoNovidadeProps> = ({
	descricao,
	tipoNovidade,
	onDelete,
	indice,
	dataInserida,
}) => {
	return (
		<Card level={1} variant='default' elevation='lowest' className={estilos.cartaoNovidades}>
			<Row align='middle' gutter={[10, 8]}>
				<Col flex='auto' lg={24} md={24}>
					<Flex justify='space-between' align='center'>
						<Row>
							<Flex gap={8} align='center'>
								{iconeNotificacao(tipoNovidade)}
							</Flex>
						</Row>
						<Row>{onDelete(indice)}</Row>
					</Flex>
				</Col>

				<Col lg={24} className={estilos.colunaDescricao}>
					<Typography.Body size='medium'>{descricao}</Typography.Body>
				</Col>

				<Col lg={24}>
					<Flex justify='space-between' align='center'>
						<Typography.Label className={estilos.dataInserida}>{formatarDataPtBr(dataInserida)}</Typography.Label>
					</Flex>
				</Col>
			</Row>
		</Card>
	);
};

export default CartaoNovidades;
